import React, { useState } from "react";




const Base64ToFile = (base64:string, fileName:string) => {
    const getMimeByExtension = (name) => {
        const ext = name.split('.').pop().toLowerCase();

        const mimeTypes = {
            png: "image/png",
            jpg: "image/jpeg",
            jpeg: "image/jpeg",
            gif: "image/gif",
            pdf: "application/pdf",
            zip: "application/zip",
            doc: "application/msword",
            docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            pem: "application/x-pem-file",
        };

        return mimeTypes[ext] || "application/octet-stream";
    };


    if (!base64) return null;

    let arr = base64.split(',');
    let mime = getMimeByExtension(fileName);
    let byteString = atob(arr[arr.length - 1]);
    let ab = new ArrayBuffer(byteString.length);
    let ia = new Uint8Array(ab);

    for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }

    return new File([ab], fileName, { type: mime });

}


export default Base64ToFile;